import { CharacterCardVariant } from "@next-platform/client-common-spicy-ui";
import type { TFunction } from "i18next";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getCharacterCardVariantLabel = (variant: CharacterCardVariant, t: TFunction): string | undefined => {
  const labelMap: Partial<Record<CharacterCardVariant, string>> = {
    [CharacterCardVariant.REVIEW]: t("myCreation:card.label.underReview"),
    [CharacterCardVariant.ACTION]: t("myCreation:card.label.actionRequired"),
    [CharacterCardVariant.DRAFT_ACTION_REQUIRED]: t("myCreation:card.label.actionRequired"),
    [CharacterCardVariant.UNDER_MANUAL_REVIEW]: t("myCreation:card.label.underManualReview"),
  };

  return labelMap[variant];
};

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getCharacterCardStatusBadgeLabel = (variant: CharacterCardVariant, t: TFunction): string | string[] | undefined => {
  const badgeLabelMap: Partial<Record<CharacterCardVariant, string | string[]>> = {
    [CharacterCardVariant.PUBLIC]: t("myCreation:card.statusBadge.public"),
    [CharacterCardVariant.PRIVATE]: t("myCreation:card.statusBadge.private"),
    [CharacterCardVariant.UNLISTED]: t("myCreation:card.statusBadge.unlisted"),
    [CharacterCardVariant.ACTION]: t("myCreation:card.statusBadge.action"),
    [CharacterCardVariant.REVIEW]: t("myCreation:card.statusBadge.review"),
    [CharacterCardVariant.DRAFT]: t("myCreation:card.statusBadge.draft"),
    [CharacterCardVariant.DRAFT_ACTION_REQUIRED]: [t("myCreation:card.statusBadge.draft"), t("myCreation:card.statusBadge.action")],
  };

  return badgeLabelMap[variant];
};

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getMyChatbotDropdownActionLabels = (t: TFunction) => ({
  edit: t("myCreation:card.actions.edit"),
  delete: t("myCreation:card.actions.remove"),
  report: t("myCreation:card.actions.report"),
});
